import React, { useState } from 'react'
import JSZip from 'jszip'
import Button from '../atoms/Button'
import Spinner from '../atoms/Spinner'

const extractId = (url) => {
    const patterns = [
        /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/shorts\/|youtube\.com\/embed\/)([^&\n?#]+)/,
        /youtube\.com\/watch\?.*v=([^&\n?#]+)/,
    ]
    for (const pattern of patterns) {
        const match = url.match(pattern)
        if (match && match[1]) return match[1]
    }
    return null
}

const BulkThumbnailExtractor = () => {
    const [bulkInput, setBulkInput] = useState('')
    const [results, setResults] = useState([])
    const [isZipping, setIsZipping] = useState(false)

    const handleBulkExtract = () => {
        const urls = bulkInput.split('\n').map(u => u.trim()).filter(Boolean)
        const extracted = urls
            .map(url => {
                const id = extractId(url)
                return id ? { url, videoId: id, thumbUrl: `https://img.youtube.com/vi/${id}/hqdefault.jpg` } : null
            })
            .filter(Boolean)
        setResults(extracted)
    }

    const handleDownloadAllZip = async () => {
        setIsZipping(true)
        const zip = new JSZip()

        for (const item of results) {
            try {
                const res = await fetch(`https://img.youtube.com/vi/${item.videoId}/hqdefault.jpg`)
                const blob = await res.blob()
                zip.file(`${item.videoId}_hqdefault.jpg`, blob)
            } catch (err) {
                console.error(`Failed for ${item.videoId}:`, err)
            }
        }

        const content = await zip.generateAsync({ type: 'blob' })
        const downloadUrl = URL.createObjectURL(content)
        const a = document.createElement('a')
        a.href = downloadUrl
        a.download = 'youtube_thumbnails.zip'
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        URL.revokeObjectURL(downloadUrl)
        setIsZipping(false)
    }

    return (
        <div className="bulk-extractor">
            <label className="bulk-label">Paste multiple YouTube URLs (one per line)</label>
            <textarea
                className="bulk-textarea"
                rows={5}
                value={bulkInput}
                onChange={(e) => setBulkInput(e.target.value)}
                placeholder={"https://youtube.com/watch?v=...\nhttps://youtu.be/...\nhttps://youtube.com/shorts/..."}
            />
            <div className="bulk-buttons">
                <Button onClick={handleBulkExtract} disabled={!bulkInput.trim()}>
                    Extract All
                </Button>
                {results.length > 0 && (
                    <Button variant="secondary" onClick={handleDownloadAllZip} disabled={isZipping}>
                        {isZipping ? <Spinner size="small" /> : null}
                        {isZipping ? 'Zipping...' : `Download All (${results.length}) as ZIP`}
                    </Button>
                )}
            </div>

            {results.length > 0 && (
                <div className="bulk-results-grid">
                    {results.map((item) => (
                        <div key={item.videoId} className="bulk-result-item">
                            <img src={item.thumbUrl} alt={item.videoId} loading="lazy" />
                            <p>{item.videoId}</p>
                        </div>
                    ))}
                </div>
            )}
        </div>
    )
}

export default BulkThumbnailExtractor